import { render, staticRenderFns } from "./tabCustomerCards.vue?vue&type=template&id=6800fdfe&"
import script from "./tabCustomerCards.vue?vue&type=script&lang=js&"
export * from "./tabCustomerCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports